import script from "./TicketsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsList.vue?vue&type=script&setup=true&lang=js"

import "./TicketsList.vue?vue&type=style&index=0&id=314b9bde&scoped=true&lang=css"
import "./TicketsList.vue?vue&type=style&index=1&id=314b9bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-314b9bde"]])

export default __exports__